import { DependencyList, useEffect } from "react";

export type EffectAsyncCallback = () => Promise<void>;

export function useEffectAsync(effect: EffectAsyncCallback, deps?: DependencyList): void {
    useEffect(() => {
        effect().catch(console.error)
    // eslint-disable-next-line               
    }, deps);    
}